const TSB_FALLBACK = 'GTM-TTZVPNB';

const injected = new Set<string>();

/** Inject a GTM container into the page. Idempotent — safe to call multiple
 *  times with the same or different IDs. Falls back to TSB's container when
 *  `containerId` is null/undefined. */
export function injectGtm(containerId: string | null | undefined): void {
  const id = containerId ?? TSB_FALLBACK;
  if (injected.has(id)) return;
  injected.add(id);

  // Inline script (head equivalent) — pushes the initial gtm.start event and
  // loads the GTM script asynchronously.
  const script = document.createElement('script');
  script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${id}');`;
  document.head.appendChild(script);

  // Noscript iframe — identical to what GTM instructs to place in <body>.
  const ns = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${id}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.cssText = 'display:none;visibility:hidden';
  ns.appendChild(iframe);
  document.body.appendChild(ns);
}
